export default "__VITE_ASSET__xLF908MX__"